//////LIBRARY//////
import React, { useEffect, useState, useMemo, Fragment } from 'react'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import { cloneDeep, isEmpty, isUndefined, map, reduce, isNull, isEqual, find } from 'lodash'
//////COMPONENTS//////
import Table from '../../components/Table'
import { rgpdActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import Button from '../../components/Ui/Buttons'
import Theme from '../../theme/theme'
import Modals from '../../components/Modals'
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import { TextModal, InputLogin, ActionWrapperElem, InputWrapper, ErrorInputMsg } from '../../theme/GlobalCss'
import userPrivileges from '../../constants/PrivilegesList'
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'
import TooltipHelp from '../../components/TooltipHelp'
import TableTitle from '../../components/Table/components/TableTitle'
import ValueCheck from '../../helpers/ValueCheck'
//////ASSETS//////
import Search from '../../assets/icones/global/zoom-in.svg'
import Anonymise from '../../assets/icones/global/anonymiser.svg'
import CloseRed from '../../assets/icones/global/close-red.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
const TextModalWrapper = styled.div`
	width: 102%;
	height: auto;
	display: flex;
	flex-direction: row;
	justify-content: center;
	margin: 0;
	align-items: center;
`
const ButtonWrapper = styled.div`
	display: flex;
	height: 32px;
	justify-content: space-between;
	margin-left: 5px;
	margin-right: 5px;
	width: 100%;
`
const InputLoginCustom = styled(InputLogin)`
	width: 150px;
	border: 1px solid ${(props) => props.theme.colors.cancel};
	margin-right: 15px;
	margin-top: 5px;
	align-self: center;
	margin-bottom: 15px;
`
const AnonymTopWrapper = styled.div`
	width: 100%;
	background-color: ${(props) => props.theme.colors.whiteGrey};
	overflow-y: scroll;
	overflow-x: hidden;
	marging: 2% 1%;
	max-height: 240px;
`
const InformationWrapper = styled.div`
	width: 100%;
	margin: 2% 1%;
	background-color: ${(props) => props.theme.colors.white};
	text-align: center;
`
const AnonymMiddleWrapper = styled.div`
	width: 100%;
`
const AnonymBottomWrapper = styled.div`
	width: 100%;
	background-color: blue;
`
const ErrorInputMsgMail = styled(ErrorInputMsg)`
	position: absolute;
	bottom: -20px;
`
const ErrorMessageWrapper = styled.div`
	height: auto;
	max-width: 100%;
	display: flex;
	flex-direction: row;
	margin: 3%;
`
const ErrorMessageText = styled.div`
	height: auto;
	width: 100%;
	margin-left: 4%;
	color: ${(props) => props.theme.colors.error};
`
const ErrorBox = styled.div`
	display: flex;
	flex-direction: column;
	height: auto;
	background: #f5d7d7;
	border: 1px solid #f2c2c2;
	border-radius: 5px;
	margin-bottom: 15px;
`
const ErrorMessageImg = styled.img`
	height: auto;
	width: auto;
	margin-left: 2%;
	margin-top: 1%;
	display: flex;
	align-self: flex-start;
`
const TextModalRed = styled(TextModal)`
	color: ${(props) => props.theme.colors.error};
`
const TextModalPrimary = styled.span`
	margin: 0;
	padding: 15px 0;
	font-size: 14px;
	color: ${(props) => props.theme.colors.primary};
`
const CustomerDetailWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`
const TextModalWrapperTop = styled(TextModalWrapper)`
	display: flex;
	flex-direction: column;
`
//////STYLED//////

const Rgpd = () => {
	const { translations, rgpd, rgpdData, kioskPerimeter, user, userRolePrivileges, currentColumn, currentDir } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			rgpd: state.rgpd,
			rgpdData: state.rgpd.header,
			user: state.user,
			kioskPerimeter: state.user.identity.kioskSelected,
			userRolePrivileges: state.user.identity.rolePrivileges,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const actionsRgpd = bindActionCreators(rgpdActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	// first call to set data on table
	const onSubmit = (data) => {
		const mail = {
			userKioskScope: {
				kiosksInLocalScope: reduce(
					kioskPerimeter,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			customerEmail: data.mail,
		}
		actionsRgpd.postSearchCustomer(mail)
	}

	//////////////////////////////////// HOOK /////////////////////////////////////////////////////////

	//	Mail
	const [mail, setMail] = useState('')

	// Data
	const [inputData, setInputData] = useState([])
	const [paging, setPaging] = useState({ page: '0', size: '250', sort: 'saleOrder.createdDate', nameDir: 'desc' })

	// Modals
	const [showModalSearch, setShowModalSearch] = useState(false)
	const [showModalAno, setShowModalAno] = useState(false)

	// Form
	const [stateDefaultValues, setStateDefaultValues] = useState()
	const { register, handleSubmit, setValue, errors, getValues } = useForm({
		defaultValues: stateDefaultValues,
	})

	// Config
	const [configTableTitle, setConfigTableTitle] = useState({
		name: translations['page__rgpd__rgpdTable_title'],
		paging: {
			fnSendTo: (paging) => handlePagingRgpd(paging),
		},
	})

	//Columns
	const [columns, setColumns] = useState([])

	const [isError, setIsError] = useState(false)

	//////////////////////////////////// HANDLER FOR CALL /////////////////////////////////////////////////////////

	// second call set data ton anonymise
	const handleModalAnonymisation = (dataRow) => {
		if (dataRow.length === 0 || isUndefined(dataRow)) return // guard do nothing if no line was selected
		let checkItemFormat
		if (!isUndefined(dataRow)) {
			if (!isUndefined(dataRow.length)) {
				checkItemFormat = {
					userKioskScope: {
						kiosksInLocalScope: reduce(
							kioskPerimeter,
							(result, value) => {
								result.push(value.id)
								return result
							},
							[]
						),
					},

					idsSalesData: map(dataRow, (elem) => ({
						idSalesOrder: elem.idSalesOrder,
						idSalesOrderLine: elem.idSalesOrderLine,
					})),
				}
			} else {
				checkItemFormat = {
					userKioskScope: {
						kiosksInLocalScope: reduce(
							kioskPerimeter,
							(result, value) => {
								result.push(value.id)
								return result
							},
							[]
						),
					},

					idsSalesData: [
						{
							idSalesOrder: dataRow.idSalesOrder,
							idSalesOrderLine: dataRow.idSalesOrderLine,
						},
					],
				}
			}
			if (!showModalAno && !isNull(dataRow)) {
				actionsRgpd.postCustomerData(checkItemFormat)
				setShowModalAno(true)
			}
		}
	}
	// 3 call to send data to anonymise
	const handleAnonymiseAction = () => {
		const data = {
			userKioskScope: {
				kiosksInLocalScope: reduce(
					kioskPerimeter,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			idsSalesData: map(rgpdData, (elem) => ({
				idSalesOrder: isUndefined(elem.idSalesOrder) ? null : elem.idSalesOrder,
				idSalesOrderLine: isUndefined(elem.idSalesOrderLine) ? null : elem.idSalesOrderLine,
			})),

			customerEmail: mail,
		}

		actionsRgpd.postAnonymiseData(data)
		setShowModalAno(false)
	}

	//////////////////////////////////// HANDLER /////////////////////////////////////////////////////////

	const handlePagingRgpd = (paging) => {
		const pg = {
			...paging,
			...{
				sort: !isUndefined(currentColumn.value) ? currentColumn.value : 'saleOrder.createdDate',
				nameDir: !isUndefined(currentDir.value) ? currentDir.value : 'desc',
			},
		}
		setPaging(pg)

		// Adding missing body to request
		const m = {
			userKioskScope: {
				kiosksInLocalScope: reduce(
					kioskPerimeter,
					(result, value) => {
						result.push(value.id)
						return result
					},
					[]
				),
			},
			customerEmail: mail,
		}

		// Setting args accordingly
		actionsRgpd.postSearchCustomer(m, paging)
		setConfigTable({ ...configTable, export: { bd: m } })
	}

	const handleCloseModalSearch = () => {
		setShowModalSearch(false)
		setIsError(false)
		setMail('')
		if (!isEmpty(rgpd.error)) {
			rgpd.error = ''
		}
	}

	const handleOpenModalSearch = () => {
		setShowModalSearch(true)
		setIsError(false)
		//setMail('')
	}

	const handleModalAno = () => {
		setShowModalAno(false)
	}

	//////////////////////////////////// CONFIG /////////////////////////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'dataProtectionLaw_email',
				dataHook: 'customerEmail',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_email'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.customerEmail',
			},
			{
				columnReferential: 'dataProtectionLaw_name',
				dataHook: 'customerName',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_customerName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.customerFirstname',
			},
			{
				columnReferential: 'dataProtectionLaw_firstName',
				dataHook: 'customerLastName',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_customerLastName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.customerLastname',
			},
			{
				columnReferential: 'dataProtectionLaw_dataOrigin',
				dataHook: 'dataOrigin.translationKey',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_dataOrigin'],
				toTranslate: true,
				sortable: true,
				isAuthorize: true,
				sortableId: 'withDeposit',
			},
			{
				columnReferential: 'dataProtectionLaw_date',
				dataHook: 'dateCreated',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_date'],
				sortable: true,
				isAuthorize: true,
				component: (props) => moment(props.row.dateCreated).format('DD/MM/YYYY HH:mm'),
				sortableId: 'saleOrder.createdDate',
			},
			{
				columnReferential: 'dataProtectionLaw_store',
				dataHook: 'storeLabelToDisplay',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_storeLabel'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.kiosk.store.company.labelToDisplay',
			},
			{
				columnReferential: 'dataProtectionLaw_articleCode',
				dataHook: 'itemCode',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_itemCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'itemKiosk.itemDistributor.item.labelToDisplay',
			},
			{
				columnReferential: 'dataProtectionLaw_consignmentPriceHT',
				dataHook: 'depositPriceHT',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_depositPriceHT'],
				sortable: true,
				isAuthorize: true,
				component: (props) => ValueCheck.ValueCheck(props.row.depositPriceHT, '-', props.row.currency.symbol),
				//component: (props) => `${props.row.depositPriceHT}${props.row.currency.symbol}`,
				sortableId: 'priceDepositTotalTTC',
			},
			{
				columnReferential: 'dataProtectionLaw_totalTransactionAmountTTC',
				dataHook: 'totalAmountTTC',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_totalAmountTTC'],
				sortable: true,
				isAuthorize: true,
				component: (props) => (!isNull(props.row.totalAmountTTC) ? `${props.row.totalAmountTTC}${props.row.currency.symbol}` : '-'),
				sortableId: 'saleOrder.totalPriceTTC',
			},
			{
				columnReferential: 'dataProtectionLaw_kioskCode',
				dataHook: 'kioskCode',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_kioskCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.kiosk.labelToManufacturer',
			},
			{
				columnReferential: 'dataProtectionLaw_kioskName',
				dataHook: 'kioskName',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_kioskName'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.kiosk.description',
			},
			{
				columnReferential: 'dataProtectionLaw_clientKioskName',
				dataHook: 'customerKioskCode',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_kioskCustomerCode'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.kiosk.labelToOwner',
			},
			{
				columnReferential: 'dataProtectionLaw_transactionNumber',
				dataHook: 'idTransaction',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_transactionId'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.transactionId',
			},
			{
				columnReferential: 'dataProtectionLaw_distributor',
				dataHook: 'distributorLabelToDisplay',
				headerName: translations['page__rgpd__rgpdTable_tableHeader_distributor'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'saleOrder.distributor.company.labelToDisplay',
			},
			/* {
				action: true,
				isFixed: true,
				component: ActionsTable,

				rest: {
					clickAction: (row) => {
						handleModalAnonymisation(row)
					},
				},
				checkRight: userPrivileges.action[13],
			}, */

			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				whitIcons: false,
				checkRight: userPrivileges.action[13],
				rest: {
					tooltipPart: 'rgpdTableAction',
					paperActionsList: [
						{
							// TRAD KEY NAME?
							name: translations['tooltip__admin__rgpd__tableAction__anonymizeData'],
							translationKey: 'tooltip__admin__consignmentContract__tableAction__customerInfo_update',
							//iconDef: edit,
							clickAction: (row) => {
								handleModalAnonymisation(row)
							},
							isVisible: () => !isUndefined(find(userRolePrivileges.privileges, (o) => o.label === userPrivileges.action[13])),
							//isVisible: () => true,
						},
					],
				},
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 15,
		labelPageTable: 'dataProtectionLaw',
	}

	const [configTable, setConfigTable] = useState({
		name: translations['page__rgpd__rgpdTable_title'],

		getSelected: (getSelectedData) => {
			// button to layout for get data selected ( getSelectedData is actions.edit.getDataSelected function )

			return !isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[13])) ? (
				<ActionWrapperElem>
					<Button
						as={'div'}
						actionHandler={getSelectedData}
						img={Anonymise}
						color={Theme.colors.white}
						//text={translations['modal__rgpd__button__anonymizeSelecion']}
						text={'Anonymiser la sélection'}
						weight={'normal'}
						iconHeight={'auto'}
						iconWidth={'20px'}
						height={32}
					/>
				</ActionWrapperElem>
			) : null
		},

		openModalSearch: (modalHandlerSearch) => {
			return (
				<ActionWrapperElem>
					<Button
						as={'div'}
						actionHandler={() => setShowModalSearch(true)}
						img={Search}
						color={Theme.colors.white}
						border={'4px 0 0 4px'}
						text={'Rechercher un client'}
						weight={'normal'}
						iconHeight={'auto'}
						iconWidth={'20px'}
						height={32}
					/>
				</ActionWrapperElem>
			)
		},

		actions: {
			edit: !isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[13]))
				? {
						getDataSelected: (dataCP) => {
							handleModalAnonymisation(dataCP)
						},
						// Set a function here is not what was intended
						/*openModalSelectedSearch: () => {
		setShowModalSearch(true)
	},*/
				  }
				: null,
		},
	})

	////////////////////////////////USE EFFECT/////////////////////////////////////////

	useEffect(() => {
		setShowModalSearch(true)
	}, [])

	/* 	useEffect(() => {
			let cfg = cloneDeep(config)
			setConfig(cfg)UseEffect
		}, [translations]) */

	useEffect(() => {
		const cfgCp = cloneDeep(configTableTitle)

		cfgCp.name = translations['page__rgpd__rgpdTable_title']

		setConfigTableTitle(cfgCp)
	}, [translations])

	useEffect(() => {
		setInputData(rgpd.items)
		if (rgpd.status === 200) {
			const cfg = cloneDeep(configTableTitle)
			cfg.paging = {
				totalElements: rgpd.paging.totalElements,
				totalPages: rgpd.paging.totalPages,
				fnSendTo: (paging) => handlePagingRgpd(paging),
			}
			setConfigTableTitle(cfg)
			setConfigTable({
				...configTable,
				export: {
					bd: {
						userKioskScope: {
							kiosksInLocalScope: reduce(
								kioskPerimeter,
								(result, value) => {
									result.push(value.id)
									return result
								},
								[]
							),
						},
						customerEmail: mail,
					},
				},
			})
			// Special useEffect for setting data on table
			//setInputData(rgpd.items)
			setShowModalSearch(false)
			setIsError(false)
			//setMail('')
		}
	}, [rgpd.items])

	// Refresh data on every back call
	useEffect(() => {
		if (!isEmpty(rgpd.error)) {
			setIsError(true)
		}
	}, [rgpd.error])

	useEffect(() => {
		let str_mail = ''
		map(rgpdData, (elem) => {
			str_mail = elem.customerEmail
		})
		setValue('mail', str_mail)
		setMail(str_mail)
		setStateDefaultValues(getValues)

		if (isEqual(rgpdData, {}) && mail.length > 0) {
			const m = {
				userKioskScope: {
					kiosksInLocalScope: reduce(
						kioskPerimeter,
						(result, value) => {
							result.push(value.id)
							return result
						},
						[]
					),
				},
				customerEmail: mail,
			}

			actionsRgpd.postSearchCustomer(m)
			setConfigTable({ ...configTable, export: { bd: m } })
		}
	}, [rgpdData])

	useEffect(() => {
		actionsColumns.setColumns([])

		return function cleanUp() {
			actionsRgpd.resetDataRGPD()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		if (isEmpty(mail)) {
			rgpd.error = false
			setIsError(false)
		}
	}, [mail])

	useEffect(() => {
		let configCp = {
			getSelected: (getSelectedData) => {
				// button to layout for get data selected ( getSelectedData is actions.edit.getDataSelected function )

				return !isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[13])) ? (
					<ActionWrapperElem>
						<Button
							as={'div'}
							actionHandler={getSelectedData}
							img={Anonymise}
							color={Theme.colors.white}
							text={translations['modal__rgpd__button__anonymizeSelecion']}
							//text={"Anonymiser la sélection"}
							weight={'normal'}
							iconHeight={'auto'}
							iconWidth={'20px'}
							height={32}
						/>
					</ActionWrapperElem>
				) : null
			},

			openModalSearch: () => {
				return (
					<ActionWrapperElem>
						<Button
							as={'div'}
							actionHandler={() => setShowModalSearch(true)}
							img={Search}
							color={Theme.colors.white}
							border={'4px 0 0 4px'}
							//text={'Rechercher un client'}
							text={translations['modal__rgpd__button__searchCustomer']}
							weight={'normal'}
							iconHeight={'auto'}
							iconWidth={'20px'}
							height={32}
						/>
					</ActionWrapperElem>
				)
			},
		}
	}, [translations])

	const handleReset = () => {
		setIsError(false)
		actionsRgpd.resetUnknownMailError()
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={inputData}
				inputConfig={configTable}
				currentPaging={paging}
				tableReferential={tableReferential}
				actionSort={actionsRgpd.postSearchCustomer}
			/>
		)
	}, [inputData, columns, configTable, translations, paging])

	return (
		<Fragment>
			{/*MODAL RECHERCHE*/}

			{showModalSearch && (
				<Modals
					closeModalHandler={handleCloseModalSearch}
					showModal={showModalSearch}
					title={translations['modal__rgpd__title__searchCustomer']}
					maxWidth={555}
					icon={true}
				>
					<TextModalWrapper>
						<TooltipHelp content={'tooltipHelp__admin__modal__body__rgpd__modal__searchCustomer'} insideModal>
							<TextModalPrimary>{translations['modal__rgpd__body__searchCustomer']}</TextModalPrimary>
						</TooltipHelp>
					</TextModalWrapper>
					<form onSubmit={handleSubmit(onSubmit)}>
						<InputWrapper>
							<InputLoginCustom
								name="mail"
								type="text"
								placeholder={
									isEmpty(mail) &&
									translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_email']
								}
								//value={mail}
								onChange={(e) => setMail(e.target.value)}
								onFocus={() => handleReset()}
								ref={register({
									required: {
										value: true,
										message: translations['common__text__requiredField'],
									},
									maxLength: {
										value: 150,
										message: `150 ${translations['common__text__charMax']}`,
									},
									pattern: {
										//value: RegExp(/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
										value: /^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
										message: '',
									},
								})}
							/>
							{errors?.mail?.type === 'required' && <ErrorInputMsg>{errors?.mail.message}</ErrorInputMsg>}
						</InputWrapper>
						{errors?.mail && !isEmpty(mail) && (
							<ErrorBox>
								<ErrorMessageWrapper>
									<ErrorMessageImg src={CloseRed} />
									<ErrorMessageText> {translations['common__message__rgpd__searchCustomer_invalidEmail']} </ErrorMessageText>
								</ErrorMessageWrapper>
							</ErrorBox>
						)}

						{isError && (
							<ErrorBox>
								<ErrorMessageWrapper>
									<ErrorMessageImg src={CloseRed} />
									<ErrorMessageText> {translations['common__message__rgpd__searchCustomer_uknownEmail']} </ErrorMessageText>
								</ErrorMessageWrapper>
							</ErrorBox>
						)}
						<ButtonWrapper>
							<Button
								actionHandler={handleCloseModalSearch}
								text={translations['common__text__cancel']}
								bgColor={Theme.colors.error}
								margin="true"
								img={Cancel}
							/>
							<Button
								actionHandler={handleOpenModalSearch}
								text={translations['common__text__validate']}
								bgColor={Theme.colors.validation}
								img={Validation}
							/>
						</ButtonWrapper>
					</form>
				</Modals>
			)}

			{/*MODAL ANONYMISATION*/}

			<Modals
				closeModalHandler={handleModalAno}
				showModal={showModalAno}
				title={translations['modal__rgpd__title__anonymizeCustomerData']}
				level="error"
				icon={true}
				maxWidth={480}
				maxHeight={599}
			>
				<TextModalWrapper>
					<TextModal>{translations['modal__rgpd__body__anonymizeCustomerData__explainText']}</TextModal>
				</TextModalWrapper>

				<AnonymTopWrapper>
					{map(rgpdData, (elem, _id) => (
						<InformationWrapper>
							<TextModalWrapperTop>
								<TextModal style={{ paddingBottom: '2px' }}>{translations[elem.dataOrigin.translationKey?.toString()]}</TextModal>
								{elem.dataOrigin.translationKey.toString() === 'page__rgpd__rgpdTable_tableHeader_dataOrigin_sales' ? (
									<TextModalPrimary style={{ padding: '0' }}>
										{' '}
										&#91;{translations['modal__rgpd__body__anonymizeCustomerData__transactionNumber']} {elem.idTransaction} du{' '}
										{moment(elem.dateCreated).format('DD/MM/YYYY')} - {elem.customerName} {elem.customerLastName}&#93;
									</TextModalPrimary>
								) : (
									<TextModalPrimary style={{ padding: '0' }}>
										{' '}
										&#91;{translations['modal__rgpd__body__anonymizeCustomerData__consignmentNumber']} {elem.idTransaction} du{' '}
										{moment(elem.dateCreated).format('DD/MM/YYYY')} - {elem.customerName} {elem.customerLastName}&#93;
									</TextModalPrimary>
								)}
							</TextModalWrapperTop>
							<CustomerDetailWrapper>
								<TextModalWrapper>
									<TextModal style={{ paddingBottom: '5px' }}>
										{elem.customerName} {elem.customerLastName}{' '}
										<TextModalPrimary>{translations['common__text__becomes']}</TextModalPrimary> {elem.anonymousCustomerAllName}
									</TextModal>
								</TextModalWrapper>
								<TextModalWrapper>
									<TextModal style={{ paddingTop: '5px' }}>
										{elem.customerEmail} <TextModalPrimary>{translations['common__text__becomes']}</TextModalPrimary>{' '}
										{elem.anonymousCustomerEmail}
									</TextModal>
								</TextModalWrapper>
							</CustomerDetailWrapper>
						</InformationWrapper>
					))}
				</AnonymTopWrapper>
				<AnonymMiddleWrapper>
					<TextModalWrapper></TextModalWrapper>
				</AnonymMiddleWrapper>
				<AnonymBottomWrapper></AnonymBottomWrapper>
				<TextModalWrapper>
					<TextModal>{translations['modal__rgpd__body__anonymizeCustomerData__email__title__explainText']} :</TextModal>
					<InputWrapper>
						<InputLogin
							name="mail"
							type="email"
							onChange={(e) => setMail(e.target.value)}
							placeholder={translations['page__transactionsHistory__admin__consignmentContract__modalCommon__placeHolder_email']}
							ref={register({
								required: {
									value: true,
									message: translations['common__text__requiredField'],
									name: '',
								},
								maxLength: {
									value: 150,
									message: `150 ${translations['common__text__charMax']}`,
								},
								pattern: {
									value: RegExp(
										/^(([^<>()\[\]\\.,;:\s@\"]+(\.[^<>()\[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
									),
									message: '',
								},
							})}
						/>
						{errors?.mail?.type === 'required' && <ErrorInputMsgMail>{errors?.mail.message}</ErrorInputMsgMail>}
					</InputWrapper>
				</TextModalWrapper>
				<TextModal>
					{errors?.mail && (
						<ErrorBox>
							<ErrorMessageWrapper>
								<ErrorMessageImg src={CloseRed} />
								<ErrorMessageText> {translations['common__message__rgpd__searchCustomer_invalidEmail']} </ErrorMessageText>
							</ErrorMessageWrapper>
						</ErrorBox>
					)}{' '}
				</TextModal>
				<TextModal>{translations['modal__rgpd__body__anonymizeCustomerData__email__content__explainText']}</TextModal>
				<TextModalWrapper>
					<TextModalRed>{translations['modal__rgpd__body__anonymizeCustomerData__email__warning__explainText']}</TextModalRed>
				</TextModalWrapper>

				<ButtonWrapper>
					<Button
						actionHandler={handleModalAno}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Cancel}
					/>
					<Button
						actionHandler={() => handleAnonymiseAction()}
						text={translations['modal__rgpd__body__anonymizeCustomerData__button__anonymizeSendSummaryData']}
						bgColor={Theme.colors.validation}
						disabled={isEqual(rgpdData, {}) || isEmpty(rgpdData)}
						img={Validation}
					/>
				</ButtonWrapper>
			</Modals>
			<UsersManagerWrapper>
				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

Rgpd.propTypes = {}

Rgpd.defaultPropTypes = {}

export default Rgpd
